(function () {
  'use strict';

  var SAMPLER_VARIANT_ID = '53707124343102';
  // Gingham Harvest Set: the free mini sampler is included with it, so it may share the cart.
  var SAMPLER_ALLOWED_WITH_PRODUCT_IDS = ['12659249348926'];
  var cartState = null;
  var cartRequest = null;

  var messages = {
    samplerAlreadyInCart: 'Limit one free mini sampler per order.',
    samplerNeedsEmptyCart: 'The free mini sampler must be ordered separately. Please empty your cart before adding it.',
    removeSamplerFirst: 'The free mini sampler must be ordered separately. Remove it before adding other products.',
    invalidCart: 'The free mini sampler must be the only item in your cart, with quantity 1.'
  };

  function normalizeId(value) {
    return String(value || '').split('/').pop();
  }

  function cartSummary(cart) {
    var summary = {
      samplerQuantity: 0,
      otherQuantity: 0,
      hasHarvestSet: false,
      harvestSets: 0
    };

    if (!cart || !Array.isArray(cart.items)) return summary;

    cart.items.forEach(function (item) {
      var quantity = Number(item.quantity || 0);
      if (normalizeId(item.variant_id || item.id) === SAMPLER_VARIANT_ID) {
        summary.samplerQuantity += quantity;
      } else {
        summary.otherQuantity += quantity;
      }
      if (quantity > 0 && SAMPLER_ALLOWED_WITH_PRODUCT_IDS.indexOf(normalizeId(item.product_id)) !== -1) {
        summary.hasHarvestSet = true;
        summary.harvestSets += quantity;
      }
    });

    return summary;
  }

  function isInvalidSamplerCart(cart) {
    var summary = cartSummary(cart);
    // Harvest carts carry their own sampler; the cart sync removes the standalone one.
    if (summary.hasHarvestSet) return false;
    return summary.samplerQuantity > 1 || (summary.samplerQuantity > 0 && summary.otherQuantity > 0);
  }

  // One Pound + Free Tote offer: tote and Mystery Hive Gift lines carry the _tote_gift property
  // and are taken to $0 by the store's "buy 1 lb, get a tote + Mystery Hive Gift" discount.
  var TOTE_POUND_VARIANT_ID = '54666161160510';   // "One Pound + Free Tote" product (was Honey Caramels / One Pound 49637147443518)
  var TOTE_GIFT_TOTE_IDS = ['51177398599998', '51177398108478', '49660363243838', '49660363276606']; // Pink Poppy, Sunflower, Purple, Orange
  var TOTE_GIFT_MYSTERY_ID = '54642415305022';    // Mystery Hive Gift
  var TOTE_MAX_POUNDS = 4;                         // up to 4 lb, each with a free tote + Mystery Hive Gift

  function isToteGiftLine(item) {
    return !!(item && item.properties && item.properties._tote_gift);
  }

  function hasToteOffer(cart) {
    return !!(cart && (cart.items || []).some(function (item) { return isToteGiftLine(item) && Number(item.quantity) > 0; }));
  }

  // Gingham Harvest Set and the free tote offer: no discount codes. Their free gifts are already included, so any code
  // in the cart (typed in the cart or carried in from an email link) is removed before checkout.
  var HARVEST_NO_CODE_NOTE = 'Welcome and other discount codes can\'t be used on Gingham Harvest Sets. Your free gifts are already included.';
  var TOTE_NO_CODE_NOTE = 'Welcome and other discount codes can\'t be used with the free tote offer. Your free tote and Mystery Hive Gift are already included.';
  var clearingCodes = null;

  function hasNoCodeOffer(cart) {
    return !!cart && (cartSummary(cart).hasHarvestSet || hasToteOffer(cart));
  }

  function harvestCodes(cart) {
    if (!hasNoCodeOffer(cart)) return [];
    return (cart.discount_codes || []).filter(function (d) { return d && d.code; });
  }

  function showHarvestNote() {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]') || document;
    var button = drawer.querySelector('[name="checkout"], [data-checkout-button]');
    if (!button || !button.parentNode || drawer.querySelector('[data-harvest-no-code-note]')) return;
    var noteText = cartState && cartSummary(cartState).hasHarvestSet ? HARVEST_NO_CODE_NOTE : TOTE_NO_CODE_NOTE;
    var note = document.createElement('p');
    note.setAttribute('data-harvest-no-code-note', '');
    note.setAttribute('role', 'status');
    note.style.cssText = 'color:#453939;background:#fff1e4;margin:10px 0;padding:10px 12px;font-size:15px;line-height:1.4;font-style:normal;';
    note.style.setProperty('font-style', 'normal', 'important');
    note.style.setProperty('font-family', 'Figtree, Helvetica, Arial, sans-serif', 'important');
    note.style.setProperty('font-size', '16px', 'important');
    note.textContent = noteText;
    button.parentNode.insertBefore(note, button);
  }

  // A /discount/CODE email link also leaves the code in a discount_code cookie, and checkout applies it from there
  // even after the cart's code is cleared, so the cookie has to go too.
  function hasDiscountCookie() {
    return document.cookie.split('; ').some(function (c) { return c.indexOf('discount_code=') === 0 && c.length > 'discount_code='.length; });
  }

  function clearDiscountCookie() {
    var expired = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = expired;
    document.cookie = expired + '; domain=' + location.hostname;
    document.cookie = expired + '; domain=.' + location.hostname.replace(/^www\./, '');
  }

  function clearHarvestCodes() {
    clearDiscountCookie();
    if (clearingCodes) return clearingCodes;
    clearingCodes = fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        cartState = cart;
        showHarvestNote();
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        return cart;
      })
      .catch(function () { return cartState; })
      .finally(function () { clearingCodes = null; });
    return clearingCodes;
  }

  function enforceHarvestNoCodes(cart) {
    if (harvestCodes(cart).length) clearHarvestCodes();
    else if (hasNoCodeOffer(cart) && hasDiscountCookie()) clearDiscountCookie();
  }

  // Gingham Harvest Set free gifts: one of each gift per set, added with the _harvest_gift
  // property. Each set has its own sticker design so Shopify's free-gift rules never compete.
  var HARVEST_PRODUCT_ID = '12659249348926';
  // The Harvest mini sampler (54666122002750) is a $0 copy of the free sampler kept in the General
  // shipping profile, so it ships in the same box as the set. The standalone free sampler stays in its
  // own $7.99 profile ("Anellabees Free Sampler Offer") and is removed from carts that hold a Harvest Set.
  var HARVEST_SAMPLER_ID = '54666122002750';
  var HARVEST_SETS = {
    '54616319328574': ['49843832979774', HARVEST_SAMPLER_ID],                                   // Spice: Let it Bee sticker
    '54616320278846': ['49843832848702', '49767801258302', HARVEST_SAMPLER_ID],                 // Midnight: Bee Kind sticker, raw honey
    '54616320311614': ['49843832881470', '49767801258302', '54642415305022', HARVEST_SAMPLER_ID] // Autumn: Save the Bees sticker, raw honey, Mystery Hive Gift
  };
  var HARVEST_GIFT_IDS = ['49843832979774', '49843832848702', '49843832881470', '49767801258302', '54642415305022', HARVEST_SAMPLER_ID];
  var syncingGifts = null;

  function isHarvestGiftLine(item) {
    return !!(item && item.properties && item.properties._harvest_gift);
  }

  function harvestGiftPlan(cart) {
    var want = {};
    HARVEST_GIFT_IDS.forEach(function (id) { want[id] = 0; });
    var sets = 0;
    (cart && cart.items || []).forEach(function (item) {
      var gifts = HARVEST_SETS[normalizeId(item.variant_id)];
      if (!gifts || normalizeId(item.product_id) !== HARVEST_PRODUCT_ID) return;
      sets += Number(item.quantity || 0);
      gifts.forEach(function (id) { want[id] += Number(item.quantity || 0); });
    });

    var updates = {};
    var adds = [];
    HARVEST_GIFT_IDS.forEach(function (id) {
      var lines = (cart.items || []).filter(function (item) { return normalizeId(item.variant_id) === id && isHarvestGiftLine(item); });
      if (!lines.length) {
        if (want[id] > 0) adds.push({ id: Number(id), quantity: want[id], properties: { _harvest_gift: '1' } });
        return;
      }
      lines.forEach(function (item, i) {
        var target = i === 0 ? want[id] : 0;
        if (Number(item.quantity) !== target) updates[item.key] = target;
      });
    });

    var samplers = (cart.items || []).filter(function (item) { return normalizeId(item.variant_id) === SAMPLER_VARIANT_ID; });
    // Standalone free sampler: none in a Harvest cart (the set brings its own), one per order otherwise.
    samplers.forEach(function (item, i) {
      var target = sets > 0 ? 0 : (i === 0 ? 1 : 0);
      if (Number(item.quantity) !== target) updates[item.key] = target;
    });

    // Free tote offer: one gift tote + one Mystery Hive Gift per pound of Honey Caramels, once the shopper is in the
    // offer (any _tote_gift line in the cart). Fewer pounds: extra gift lines come out. More pounds (the + button):
    // a free tote is added in the design they have the fewest of (shop order breaks ties), plus a Mystery Hive Gift.
    var pounds = 0;
    var inToteOffer = hasToteOffer(cart);
    // The offer goes up to 4 lb, so with offer gifts in the cart the caramels stop at 4.
    (cart && cart.items || []).forEach(function (item) {
      if (normalizeId(item.variant_id) !== TOTE_POUND_VARIANT_ID || isToteGiftLine(item)) return;
      var qty = Number(item.quantity || 0);
      if (inToteOffer && pounds + qty > TOTE_MAX_POUNDS) {
        qty = Math.max(0, TOTE_MAX_POUNDS - pounds);
        updates[item.key] = qty;
      }
      pounds += qty;
    });
    var toteLines = {};   // design id -> [line items]
    var toteCount = {};   // design id -> target quantity
    TOTE_GIFT_TOTE_IDS.forEach(function (id) { toteLines[id] = []; toteCount[id] = 0; });
    var toteRoom = pounds;
    // cart.items lists the newest line first; walk oldest first so the totes the shopper picked are kept
    // and the most recently added ones come out first.
    (cart.items || []).slice().reverse().forEach(function (item) {
      var id = normalizeId(item.variant_id);
      if (!isToteGiftLine(item) || !toteLines[id]) return;
      var target = Math.min(Number(item.quantity || 0), toteRoom);
      toteRoom -= target;
      toteLines[id].push(item);
      if (toteLines[id].length > 1) {   // keep one line per design
        if (Number(item.quantity) !== 0) updates[item.key] = 0;
        toteCount[id] += target;
        return;
      }
      toteCount[id] = target;
    });
    var giftTotes = pounds - toteRoom;
    if (inToteOffer && giftTotes < pounds) {
      for (var n = giftTotes; n < pounds; n++) {
        var pick = TOTE_GIFT_TOTE_IDS.reduce(function (best, id) { return toteCount[id] < toteCount[best] ? id : best; }, TOTE_GIFT_TOTE_IDS[0]);
        toteCount[pick] += 1;
      }
      giftTotes = pounds;
    }
    TOTE_GIFT_TOTE_IDS.forEach(function (id) {
      var line = toteLines[id][0];
      if (line) {
        if (Number(line.quantity) !== toteCount[id]) updates[line.key] = toteCount[id];
      } else if (toteCount[id] > 0) {
        adds.push({ id: Number(id), quantity: toteCount[id], properties: { _tote_gift: '1' } });
      }
    });
    var mysteryLines = (cart.items || []).filter(function (item) {
      return isToteGiftLine(item) && normalizeId(item.variant_id) === TOTE_GIFT_MYSTERY_ID;
    });
    mysteryLines.forEach(function (item, i) {
      var target = i === 0 ? giftTotes : 0;
      if (Number(item.quantity) !== target) updates[item.key] = target;
    });
    if (!mysteryLines.length && giftTotes > 0) adds.push({ id: Number(TOTE_GIFT_MYSTERY_ID), quantity: giftTotes, properties: { _tote_gift: '1' } });
    // The Mystery Hive Gift is never sold on its own: any line that isn't a Harvest or tote-offer gift comes out.
    (cart.items || []).forEach(function (item) {
      if (normalizeId(item.variant_id) === TOTE_GIFT_MYSTERY_ID && !isToteGiftLine(item) && !isHarvestGiftLine(item) && Number(item.quantity) !== 0) {
        updates[item.key] = 0;
      }
    });

    return { updates: updates, adds: adds, changed: Object.keys(updates).length > 0 || adds.length > 0 };
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function syncHarvestGifts(cart) {
    if (syncingGifts) return syncingGifts;
    var plan = harvestGiftPlan(cart || cartState || {});
    if (!plan.changed) return Promise.resolve(cart || cartState);
    syncingGifts = Promise.resolve()
      .then(function () { return Object.keys(plan.updates).length ? postJson('/cart/update.js', { updates: plan.updates }) : null; })
      .then(function () { return plan.adds.length ? postJson('/cart/add.js', { items: plan.adds }) : null; })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }); })
      .then(function (response) { return response.json(); })
      .then(function (fresh) {
        cartState = fresh;
        updatePageControls();
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        return fresh;
      })
      .catch(function () { return cartState; })
      .finally(function () { syncingGifts = null; });
    return syncingGifts;
  }
  window.anellabeesSyncHarvestGifts = function () {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { cartState = cart; return syncHarvestGifts(cart); });
  };
  // Same sync covers the free tote offer's gift lines.
  window.anellabeesSyncGifts = window.anellabeesSyncHarvestGifts;

  function fetchCart() {
    if (cartRequest) return cartRequest;

    cartRequest = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(function (cart) {
        cartState = cart;
        updatePageControls();
        enforceHarvestNoCodes(cart);
        syncHarvestGifts(cart);
        return cart;
      })
      .catch(function () {
        return cartState;
      })
      .finally(function () {
        cartRequest = null;
      });

    return cartRequest;
  }

  function getVariantId(form) {
    if (!form) return '';
    try {
      return normalizeId(new FormData(form).get('id'));
    } catch (error) {
      var input = form.querySelector('[name="id"]');
      return normalizeId(input && input.value);
    }
  }

  function getQuantityInput(form) {
    if (!form) return null;
    return form.querySelector('[name="quantity"]') ||
      (form.id ? document.querySelector('[name="quantity"][form="' + form.id + '"]') : null);
  }

  function forceQuantityOne(form) {
    var input = getQuantityInput(form);
    if (input) {
      input.value = '1';
      input.setAttribute('max', '1');
    }
  }

  function restrictionFor(variantId, cart) {
    var summary = cartSummary(cart);

    if (variantId === SAMPLER_VARIANT_ID) {
      if (summary.samplerQuantity > 0) return messages.samplerAlreadyInCart;
      if (summary.otherQuantity > 0 && !summary.hasHarvestSet) return messages.samplerNeedsEmptyCart;
      return '';
    }

    if (summary.samplerQuantity > 0 && !summary.hasHarvestSet) return messages.removeSamplerFirst;
    return '';
  }

  function showMessage(form, message) {
    document.querySelectorAll('[data-mini-sampler-restriction-message]').forEach(function (element) {
      element.remove();
    });

    var notice = document.createElement('p');
    notice.setAttribute('data-mini-sampler-restriction-message', '');
    notice.setAttribute('role', 'alert');
    notice.style.color = '#a12720';
    notice.style.margin = '10px 0';
    notice.style.fontWeight = '600';
    notice.textContent = message;

    if (form) {
      var button = form.querySelector('[type="submit"]');
      if (button && button.parentNode) {
        button.parentNode.insertBefore(notice, button);
      } else {
        form.appendChild(notice);
      }
    } else {
      window.alert(message);
    }

    notice.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function updatePageControls() {
    var summary = cartSummary(cartState);

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var variantId = getVariantId(form);
      if (variantId === SAMPLER_VARIANT_ID) forceQuantityOne(form);

      var quantityInput = getQuantityInput(form);
      if (variantId === SAMPLER_VARIANT_ID && quantityInput) {
        quantityInput.setAttribute('max', '1');
        if (Number(quantityInput.value || 1) > 1) quantityInput.value = '1';
      }

      var quantityWrapper = quantityInput && quantityInput.closest('[data-quantity-selector]');
      var plusButton = quantityWrapper && quantityWrapper.querySelector('[data-increase-quantity]');
      if (variantId === SAMPLER_VARIANT_ID && plusButton) {
        plusButton.disabled = true;
        plusButton.setAttribute('aria-disabled', 'true');
        plusButton.setAttribute('title', messages.samplerAlreadyInCart);
      }

      var submitButton = form.querySelector('[type="submit"]');
      if (!submitButton) return;

      if (variantId === SAMPLER_VARIANT_ID && summary.samplerQuantity > 0) {
        submitButton.setAttribute('data-mini-sampler-limit-reached', 'true');
      } else {
        submitButton.removeAttribute('data-mini-sampler-limit-reached');
      }
    });
  }

  function handleCartAddSubmit(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!String(form.getAttribute('action') || '').includes('/cart/add')) return;

    if (form.dataset.miniSamplerRestrictionBypass === 'true') {
      delete form.dataset.miniSamplerRestrictionBypass;
      return;
    }

    var variantId = getVariantId(form);
    if (!variantId) return;

    if (variantId === SAMPLER_VARIANT_ID) forceQuantityOne(form);

    if (cartState) {
      var message = restrictionFor(variantId, cartState);
      if (message) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showMessage(form, message);
      }
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    var submitter = event.submitter;

    fetchCart().then(function (cart) {
      var message = restrictionFor(variantId, cart);
      if (message) {
        showMessage(form, message);
        return;
      }

      form.dataset.miniSamplerRestrictionBypass = 'true';
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter || undefined);
      } else {
        form.submit();
      }
    });
  }

  function handleQuantityInteraction(event) {
    // Free tote offer: the caramels can't go past 4 lb while the offer's gifts are in the cart.
    var poundRow = event.target.closest('[data-cart-item][data-variant-id="' + TOTE_POUND_VARIANT_ID + '"]');
    if (poundRow && !poundRow.hasAttribute('data-harvest-gift') && hasToteOffer(cartState)) {
      var poundInput = poundRow.querySelector('[data-quantity-input]');
      var plus = event.target.closest('[data-increase-quantity]');
      if (plus && poundInput && Number(poundInput.value || 0) >= TOTE_MAX_POUNDS) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (event.type === 'change' && poundInput && event.target === poundInput && Number(poundInput.value || 0) > TOTE_MAX_POUNDS) {
        poundInput.value = String(TOTE_MAX_POUNDS);
      }
    }

    var row = event.target.closest('[data-cart-item][data-variant-id="' + SAMPLER_VARIANT_ID + '"]');
    if (!row) return;

    if (event.target.closest('[data-increase-quantity]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage(row.closest('form'), messages.samplerAlreadyInCart);
      return;
    }

    var input = event.target.closest('[data-quantity-input]');
    if (input && Number(input.value || 1) > 1) {
      input.value = '1';
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage(row.closest('form'), messages.samplerAlreadyInCart);
    }
  }

  function handleCheckout(event) {
    var checkoutControl = event.target.closest('[name="checkout"], [href*="/checkout"], [data-checkout-button]');
    if (!checkoutControl) return;

    if (cartState && hasNoCodeOffer(cartState) && !isInvalidSamplerCart(cartState)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clearDiscountCookie();
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) { return harvestCodes(cart).length ? clearHarvestCodes() : cart; })
        .then(function (cart) { cartState = cart || cartState; return syncHarvestGifts(cartState); })
        .catch(function () {})
        .then(function () { window.location.href = '/checkout'; });
      return;
    }

    if (!isInvalidSamplerCart(cartState)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showMessage(checkoutControl.closest('form'), messages.invalidCart);
  }

  document.addEventListener('submit', handleCartAddSubmit, true);
  document.addEventListener('click', handleQuantityInteraction, true);
  document.addEventListener('change', handleQuantityInteraction, true);
  document.addEventListener('click', handleCheckout, true);

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      cartState = event.detail.cart;
      updatePageControls();
      enforceHarvestNoCodes(cartState);
      syncHarvestGifts(cartState);
    }
  });

  document.addEventListener('theme:cart:init', function () {
    fetchCart();
  });

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart();
    updatePageControls();
  });
})();
